<template>
  <v-container >
    <h2>Notícia</h2>
    <template v-if="!article">
      <v-skeleton-loader class="mb-4" type="heading"></v-skeleton-loader>
      <v-skeleton-loader class="mb-4" type="chip"></v-skeleton-loader>
      <v-skeleton-loader class="mb-4" type="image"></v-skeleton-loader>
      <v-skeleton-loader class="mb-4" type="paragraph" ></v-skeleton-loader>
      <v-skeleton-loader type="paragraph" ></v-skeleton-loader>
    </template>
    <div class="article-post" v v-else>
      <h4>{{ article.title }}</h4>
      <time :datetime="article.date">{{ time }}</time>
      <img class="elevation-2 my-4" :src="files + article.img" :alt="article.title">
      <div v-html="article.text"></div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    article: null
  }),
  computed: {
    files() {
      return this.$store.state.files + '/'
    },
    time() {
      return new Intl.DateTimeFormat('pt-BR').format(new Date(this.article.date))
    }
  },
   mounted() {
    this.$store.dispatch('getAllArticles').then(() => {
      const articles = this.$store.state.articles.filter(v => v.link === this.$route.params.article)
      
      if(!articles.length) this.$router.push('/error404')

      this.article = articles[0]
    })
  }
}
</script>

<style>
.article-post {
  display: grid;
  grid-template:
    "title title title"
    "time  time  ."
    ".     img   ."
    "text  text  text"/ 1fr auto 1fr;
  align-content: start
}
.article-post > h4 {
  grid-area: title;
}
.article-post > time {
  grid-area: time;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0,0,0,.5);
}
.article-post > img {
  grid-area: img;
  border-radius: 4px;
  max-height: 400px;
  max-width: 100%;
}
.article-post > div {
  grid-area: text;
  word-break: break-word;
}
.article .article-list {
  display: grid;
  grid-auto-flow: row;
  gap: 10px;
}
</style>